import { render, staticRenderFns } from "./model-tags.vue?vue&type=template&id=4c29cb31&scoped=true"
import script from "./model-tags.vue?vue&type=script&lang=js"
export * from "./model-tags.vue?vue&type=script&lang=js"
import style0 from "./model-tags.vue?vue&type=style&index=0&id=4c29cb31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29cb31",
  null
  
)

export default component.exports